<div class="d-flex justify-content-between align-items-center mb-4x">
  <h1 class="title-lg">Load Vehicle on Auction</h1>
  <button ds-button appearance="secondary" (click)="openAssociateDetailsModal()">Vehicles on Auction</button>
</div>
<ds-box>
   <ds-box-content class="w-100"> 
    <div>
      <!-- Tabs -->
      <div>
<!--        <ds-tabs style="width: 100%" activeTabId="requestTab">-->

          <!-- Tab Labels -->
<!--          <ds-tabs-label for="requestTab" (click)="onRequestTabClick()">Load Single Vehicle</ds-tabs-label>-->
<!--          <ds-tabs-label for="overviewTab" (click)="onOverviewTabClick()">Load Multiple Vehicles</ds-tabs-label>-->

          <!-- Load Single Vehicle Tab -->
<!--          <ds-tabs-content id="requestTab" class="w-100">-->
            <div class="tab-content mt-4 w-100">
              <!-- Header -->
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <h2>VEHICLE DETAILS</h2>
                  <p class="text-sm text-gray-600 mb-0">
                    <br />
                    Please enter the vehicle details below to load it on auction.
                  </p>
                  <p class="text-xs text-danger font-medium mt-1 mb-0"><br />Required fields*</p>
                </div>
                <a class="clear-filters-link"
                   href="#"
                   (click)="clearAllFilters(); $event.preventDefault()">
                  <ds-icon icon="filter_delete"></ds-icon>
                  <div class="align_clear">Clear Filters</div>
                </a>
              </div>
              <br />

              <!-- Vehicle Information Section -->
              <h3 class="section-title mb-3">Vehicle Information</h3>
              
              <!-- Form Row 1 -->
              <div class="row gx-3 align-items-end">
                <!-- Vehicle Type -->
                <div class="col-md-4">
                  <ds-form-field>
                    <label ds-label class="form-label" for="vehicleTypeSelect">Vehicle Type *</label>
                    <ds-select
   required
                      id="vehicleTypeSelect"
                      [options]="vehicleTypes"
                      [(value)]="loadVehicleForm.vehicleType"
                      [labellingConfig]="{ placeholder: 'Please Select a Vehicle Type' }"
                      (valueChange)="onVehicleTypeChange(loadVehicleForm.vehicleType)"
                    ></ds-select>
                  </ds-form-field>
                </div>

                <!-- Model Year -->
                <div class="col-md-4">
                  <ds-form-field>
                    <label ds-label class="form-label" for="modelYearSelect">Model Year *</label>
                    <ds-select
   required
                      id="modelYearSelect"
                      [options]="modelYearOptions"
                      [(value)]="loadVehicleForm.modelYear"
                      [labellingConfig]="{ placeholder: 'Please Select a Year' }"
                      [disabled]="!loadVehicleForm.vehicleType"
                      (valueChange)="onModelYearChange(loadVehicleForm.vehicleType, loadVehicleForm.modelYear)"
                    ></ds-select>
                  </ds-form-field>
                </div>

                <!-- Brand -->
                <div class="col-md-4">
                  <ds-form-field>
                    <label ds-label class="form-label" for="brandSelect">Brand *</label>
                    <ds-select
   required
                      id="brandSelect"
                      [options]="brandOptions"
                      [(value)]="loadVehicleForm.brand"
                      [labellingConfig]="{ placeholder: 'Please Select a Brand' }"
                      [disabled]="!loadVehicleForm.modelYear"
                      (valueChange)="onBrandChange(loadVehicleForm.vehicleType, loadVehicleForm.modelYear, loadVehicleForm.brand)"
                    ></ds-select>
                  </ds-form-field>
                </div>
              </div>
              <br />

              <!-- Form Row 2 -->
              <div class="row gx-3">
                <!-- Model -->
                <div class="col-md-4">
                  <ds-form-field>
                    <label ds-label class="form-label" for="modelSelect">Model *</label>
                    <ds-select
   required
                      id="modelSelect"
                      [options]="modelOptions"
                      [(value)]="loadVehicleForm.model"
                      [labellingConfig]="{ placeholder: 'Please Select a Model' }"
                      [disabled]="!loadVehicleForm.brand"
                      (valueChange)="onModelChange(loadVehicleForm.vehicleType, loadVehicleForm.modelYear, loadVehicleForm.brand, loadVehicleForm.model)"
                    ></ds-select>
                  </ds-form-field>
                </div>

                <!-- Fuel Type -->
                <div class="col-md-4">
                  <ds-form-field>
                    <label ds-label class="form-label" for="fuelTypeSelect">Fuel Type *</label>
                    <ds-select
   required
                      id="fuelTypeSelect"
                      [options]="fuelTypeOptions"
                      [(value)]="loadVehicleForm.fuelType"
                      [labellingConfig]="{ placeholder: 'Please Select Fuel' }"
                      [disabled]="!loadVehicleForm.model"
                      (valueChange)="onFuelTypeChange(loadVehicleForm.vehicleType, loadVehicleForm.modelYear, loadVehicleForm.brand, loadVehicleForm.model, loadVehicleForm.fuelType)"
                    ></ds-select>
                  </ds-form-field>
                </div>

                <!-- Transmission Type -->
                <div class="col-md-4">
                  <ds-form-field>
                    <label ds-label class="form-label" for="transmissionTypeSelect">Transmission Type *</label>
                    <ds-select
   required
                      id="transmissionTypeSelect"
                      [options]="transmissionTypeOptions"
                      [(value)]="loadVehicleForm.transmissionType"
                      [labellingConfig]="{ placeholder: 'Please Select Transmission' }"
                      [disabled]="!loadVehicleForm.fuelType"
                      (valueChange)="onTransmissionTypeChange(loadVehicleForm.vehicleType, loadVehicleForm.modelYear, loadVehicleForm.brand, loadVehicleForm.model, loadVehicleForm.fuelType, loadVehicleForm.transmissionType)"
                    ></ds-select>
                  </ds-form-field>
                </div>
              </div>
              <br />

              <!-- Form Row 3 -->
              <div class="row gx-3">
                <!-- Variant -->
                <div class="col-md-4">
                  <ds-form-field>
                    <label ds-label class="form-label" for="variantSelect">Variant *</label>
                    <ds-select
                      required
                      id="variantSelect"
                      [options]="variantOptions"
                      [(value)]="loadVehicleForm.variant"
                      (valueChange)="onVariantChange($event)"
                      [labellingConfig]="{ placeholder: 'Please Select a Variant' }"
                      [disabled]="!loadVehicleForm.transmissionType"
                    ></ds-select>
                  </ds-form-field>
                </div>

                <!-- ADG Code -->
                <div class="col-md-4">
                  <ds-form-field>
                    <label ds-label class="form-label" for="adgCodeInput">ADG Code *</label>
                    <input
                      required
                      id="adgCodeInput"
                      ds-input
                      type="text"
                      [(ngModel)]="loadVehicleForm.adgCode"
                      placeholder="Enter ADG Code"
                      [disabled]="!loadVehicleForm.variant"
                    />
                  </ds-form-field>
                </div>

                <!-- VIN -->
                <div class="col-md-4">
                  <ds-form-field>
                    <label ds-label class="form-label">VIN *</label>
                    <input
                      required
                      ds-input
                      type="text"
                      [(ngModel)]="loadVehicleForm.vin"
                      placeholder="Enter VIN"
                    />
                  </ds-form-field>
                </div>
              </div>
              <br />

              <!-- Form Row 4 -->
              <div class="row gx-3">
                <!-- Registration Nr -->
                <div class="col-md-4">
                  <ds-form-field>
                    <label ds-label class="form-label">Registration Nr *</label>
                    <input
                      ds-input
                      required
                      type="text"
                      [(ngModel)]="loadVehicleForm.registrationNr"
                      placeholder="Enter Registration Number"
                    />
                  </ds-form-field>
                </div>

                <!-- Engine Nr -->
                <div class="col-md-4">
                  <ds-form-field>
                    <label ds-label class="form-label">Engine Nr *</label>
                    <input
                      ds-input
                      type="text"
                      [(ngModel)]="loadVehicleForm.engineNr"
                      placeholder="Enter Engine Number"
                      required
                    />
                  </ds-form-field>
                </div>

                <!-- Mileage -->
                <div class="col-md-4">
                  <ds-form-field>
                    <label ds-label class="form-label">Mileage *</label>
                    <input
                      required
                      ds-input
                      type="number"
                      [(ngModel)]="loadVehicleForm.mileage"
                      placeholder="Enter Mileage"
                    />
                  </ds-form-field>
                </div>
              </div>
              <br />

              <!-- Pricing Section -->
              <h3 class="section-title mb-3">Pricing Information</h3>
              
              <!-- Form Row 5 -->
              <div class="row gx-3">
                <!-- Reserve Price -->
                <div class="col-md-6">
                  <ds-form-field>
                    <label ds-label class="form-label">Reserve Price *</label>
                    <input
                      required
                      ds-input
                      type="number"
                      [(ngModel)]="loadVehicleForm.reservePrice"
                      placeholder="Enter Reserve Price"
                    />
                  </ds-form-field>
                </div>

                <!-- Estimated Recon Price -->
                <div class="col-md-6">
                  <ds-form-field>
                    <label ds-label class="form-label">Estimated Recon Price </label>
                    <input
                      ds-input
                      type="number"
                      [(ngModel)]="loadVehicleForm.estimatedReconPrice"
                      placeholder="Enter Estimated Recon Price"
                    />
                  </ds-form-field>
                </div>
              </div>
              <br />

              <!-- Additional Information Section -->
              <h3 class="section-title mb-3">Additional Information</h3>
              
              <!-- Comments -->
              <div class="row gx-3">
                <div class="col-md-12">
                  <ds-form-field>
                    <label ds-label class="form-label">Comments</label>
                    <textarea
                      required
                      ds-input
                      [(ngModel)]="loadVehicleForm.comments"
                      placeholder="Enter any additional comments"
                      rows="3"
                    ></textarea>
                  </ds-form-field>
                </div>
              </div>
              <br />

              <!-- File Uploads Section -->
              <h3 class="section-title mb-3">Documents</h3>
              
              <!-- Form Row 6 -->
              <div class="row gx-3">
                <!-- Photographs -->
                <div class="col-md-6">
                  <ds-form-field>
                    <label ds-label class="form-label">Photographs</label>
                    <input
                      ds-input
                      type="file"
                      (change)="onPhotographsUpload($event)"
                      accept="image/*"
                      multiple
                    />
                    <small class="text-muted">Upload vehicle photographs</small>
                  </ds-form-field>
                </div>

                <!-- Condition Report -->
                <div class="col-md-6">
                  <ds-form-field>
                    <label ds-label class="form-label">Condition Report</label>
                    <input
                      ds-input
                      type="file"
                      (change)="onConditionReportUpload($event)"
                      accept=".pdf,.doc,.docx"
                    />
                    <small class="text-muted">Upload condition report (PDF, DOC, DOCX)</small>
                  </ds-form-field>
                </div>
              </div>
              <br />

              <!-- General Checks Section -->
              <h3 class="section-title mb-3">General Checks *</h3>
              
              <div class="row gx-3">
                <div class="col-md-6">
                  <!-- Checkbox 1 -->
                  <ds-form-field>
                    <label ds-checkbox-wrapper>
                      <input
                        ds-checkbox
                        type="checkbox"
                        [(ngModel)]="loadVehicleForm.checks.hasTwoKeySets"
                      />
                      <span ds-checkbox-label>Does the vehicle have 2 key sets?</span>
                    </label>
                  </ds-form-field>

                  <!-- Checkbox 2 -->
                  <ds-form-field>
                    <label ds-checkbox-wrapper>
                      <input
                        ds-checkbox
                        type="checkbox"
                        [(ngModel)]="loadVehicleForm.checks.hasTyreThread"
                      />
                      <span ds-checkbox-label>Is there more than 30% tyre thread left?</span>
                    </label>
                  </ds-form-field>

                  <!-- Checkbox 3 -->
                  <ds-form-field>
                    <label ds-checkbox-wrapper>
                      <input
                        ds-checkbox
                        type="checkbox"
                        [(ngModel)]="loadVehicleForm.checks.hasServiceHistory"
                      />
                      <span ds-checkbox-label>Does the vehicle have full service history?</span>
                    </label>
                  </ds-form-field>

                  <!-- Checkbox 4 -->
                  <ds-form-field>
                    <label ds-checkbox-wrapper>
                      <input
                        ds-checkbox
                        type="checkbox"
                        [(ngModel)]="loadVehicleForm.checks.hasWarranty"
                      />
                      <span ds-checkbox-label>Does the vehicle have running warranty?</span>
                    </label>
                  </ds-form-field>
                </div>

                <div class="col-md-6">
                  <!-- Checkbox 5 -->
                  <ds-form-field>
                    <label ds-checkbox-wrapper>
                      <input
                        ds-checkbox
                        type="checkbox"
                        [(ngModel)]="loadVehicleForm.checks.hasMotorPlan"
                      />
                      <span ds-checkbox-label>Does the vehicle have motor or service plan?</span>
                    </label>
                  </ds-form-field>

                  <!-- Checkbox 6 -->
                  <ds-form-field>
                    <label ds-checkbox-wrapper>
                      <input
                        ds-checkbox
                        type="checkbox"
                        [(ngModel)]="loadVehicleForm.checks.isRegisteredInCustomerName"
                      />
                      <span ds-checkbox-label>Is the vehicle registered in the customer's name?</span>
                    </label>
                  </ds-form-field>

                  <!-- Checkbox 7 -->
                  <ds-form-field>
                    <label ds-checkbox-wrapper>
                      <input
                        ds-checkbox
                        type="checkbox"
                        [(ngModel)]="loadVehicleForm.checks.hasAccidentHistory"
                      />
                      <span ds-checkbox-label>Has the vehicle been involved in an accident?</span>
                    </label>
                  </ds-form-field>

                  <!-- Checkbox 8 -->
                  <ds-form-field>
                    <label ds-checkbox-wrapper>
                      <input
                        ds-checkbox
                        type="checkbox"
                        [(ngModel)]="loadVehicleForm.checks.hasCIAComments"
                      />
                      <span ds-checkbox-label>For BMW vehicles, are there any comments on CIA?</span>
                    </label>
                  </ds-form-field>
                </div>
              </div>
              <br />

              <!-- Submit CTA -->
              <div class="mt-4">
             <button
               ds-button
               variant="primary"
               [disabled]="canLoad"
               (click)="onLoadVehicle()"
               [disabled]="isLoadVehicleDisabled()"
             >
               Load Vehicle
             </button>
              </div>
            </div>
<!--          </ds-tabs-content>-->

          <!-- Load Multiple Vehicles Tab -->
<!--          <ds-tabs-content id="overviewTab">-->
<!--            <div class="tab-content mt-4 w-100">-->
<!--              <h2>LOAD MULTIPLE VEHICLES ON AUCTION</h2>-->
<!--              <p class="text-sm text-gray-600 mb-4">-->
<!--                Upload a CSV file containing multiple vehicle details to load them on auction.-->
<!--              </p>-->
<!--              <br />-->

<!--              &lt;!&ndash; Upload Section &ndash;&gt;-->
<!--              <div class="row gx-3">-->
<!--                <div class="col-md-8">-->
<!--                  <ds-form-field>-->
<!--                    <label ds-label class="form-label">Vehicle Spreadsheet *</label>-->
<!--                    <input-->
<!--                      ds-input-->
<!--                      type="file"-->
<!--                      (change)="onVehicleSpreadsheetUpload($event)"-->
<!--                      accept=".csv,.xlsx,.xls"-->
<!--                    />-->
<!--                    <small class="text-muted">Upload CSV or Excel file with vehicle details</small>-->
<!--                  </ds-form-field>-->
<!--                </div>-->
<!--              </div>-->
<!--              <br />-->

<!--              &lt;!&ndash; Template Download Link &ndash;&gt;-->
<!--              <div class="mb-4">-->
<!--                <a href="#" (click)="downloadTemplate(); $event.preventDefault()" class="text-primary">-->
<!--                  <ds-icon icon="download" inline></ds-icon>-->
<!--                  Download Template-->
<!--                </a>-->
<!--              </div>-->
<!--              <br />-->

<!--              &lt;!&ndash; Submit CTA &ndash;&gt;-->
<!--              <div class="mt-4">-->
<!--                <button class="ds-button" appearance="primary" (click)="onLoadMultipleVehicles()" [disabled]="!vehicleSpreadsheetFile">-->
<!--                  Load Vehicles-->
<!--                </button>-->
<!--              </div>-->
<!--              <br />-->
<!--            </div>-->
<!--          </ds-tabs-content>-->
<!--        </ds-tabs>-->
      </div>
    </div>
 </ds-box-content> 
</ds-box>
